import { render, staticRenderFns } from "./tnc-zh.vue?vue&type=template&id=c60c32fa&scoped=true"
import script from "./tnc-zh.vue?vue&type=script&lang=js"
export * from "./tnc-zh.vue?vue&type=script&lang=js"
import style0 from "./tnc-zh.vue?vue&type=style&index=0&id=c60c32fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60c32fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c60c32fa')) {
      api.createRecord('c60c32fa', component.options)
    } else {
      api.reload('c60c32fa', component.options)
    }
    module.hot.accept("./tnc-zh.vue?vue&type=template&id=c60c32fa&scoped=true", function () {
      api.rerender('c60c32fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-zh.vue"
export default component.exports